import crypto from 'crypto-js';
import { AVATAR_SIZE } from '../utils/shared/constants';

interface Props {
    identifier?: string | null;
    size?: 'xxs' | 'xs' | 'sm';
    className?: string;
    default?: 'mp' | 'wavatar';
}

function Gravatar(props: Props) {
    const { identifier, size: sizeType, className, default: defaultType } = props;

    let size = AVATAR_SIZE.MD;
    if (sizeType === 'xxs') size = AVATAR_SIZE.XXS;
    else if (sizeType === 'xs') size = AVATAR_SIZE.XS;
    else if (sizeType === 'sm') size = AVATAR_SIZE.SM;

    // Generate Gravatar URL based on email or ID
    const getGravatarUrl = () => {
        if (!identifier) {
            return `https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&s=${size * 2}`;
        }

        const hash = crypto.MD5(identifier.trim().toLowerCase()).toString();

        return `https://www.gravatar.com/avatar/${hash}?d=${defaultType || 'mp'}&s=${size * 2}`;
    };

    return (
        <div
            className={`overflow-hidden center border rounded-circle ${className || ''}`}
            style={{
                width: size,
                height: size,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <img
                src={getGravatarUrl()}
                alt="Customer Avatar"
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                }}
            />
        </div>
    );
}


export default Gravatar;
